import {RemoteGetAuthorizations} from 'data/usecases/private/authorizations';
import {GetAuthorizations} from 'domain/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthorizations = (): GetAuthorizations =>
	new RemoteGetAuthorizations(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.authorizations),
		makeAuthorizeHttpClientDecorator(),
	);
